export type TradeKey = 'heizung' | 'klima' | 'sani' | 'elektro' | 'notdienst' | 'wartung';

export const TRADE_STYLES: Record<
  TradeKey,
  { label: string; bg: string; border: string; text: string; solid: string }
> = {
  heizung: { label: 'Heizung', bg: '#fef3c7', border: '#f59e0b', text: '#92400e', solid: '#f59e0b' },
  klima: { label: 'Klima', bg: '#dbeafe', border: '#3b82f6', text: '#1d4ed8', solid: '#3b82f6' },
  sani: { label: 'Sanitär', bg: '#dcfce7', border: '#22c55e', text: '#15803d', solid: '#22c55e' },
  elektro: { label: 'Elektro', bg: '#ede9fe', border: '#8b5cf6', text: '#6d28d9', solid: '#8b5cf6' },
  notdienst: { label: 'Notdienst', bg: '#fee2e2', border: '#ef4444', text: '#b91c1c', solid: '#ef4444' },
  wartung: { label: 'Wartung', bg: '#ccfbf1', border: '#14b8a6', text: '#0f766e', solid: '#14b8a6' },
};

export function categoryToTradeKey(category: string | null | undefined): TradeKey {
  const c = String(category ?? '').trim().toLowerCase();
  if (c.includes('heiz')) return 'heizung';
  if (c.includes('klima')) return 'klima';
  if (c.includes('sani') || c.includes('sanit')) return 'sani';
  if (c.includes('elekt')) return 'elektro';
  if (c.includes('not')) return 'notdienst';
  return 'wartung';
}

export function tradeStyleForCategory(category: string | null | undefined) {
  return TRADE_STYLES[categoryToTradeKey(category)];
}
